var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepsGroupController = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _useSteps2 = require("./useSteps");
var _useImpactFilters2 = require("./useImpactFilters");
var _useThemeFilters2 = require("./useThemeFilters");
var _useCommitments2 = require("./useCommitments");
var _useRecommendedSteps2 = require("./useRecommendedSteps");
var StepsGroupController = exports.StepsGroupController = (0, _createClass2["default"])(function StepsGroupController() {
  (0, _classCallCheck2["default"])(this, StepsGroupController);
  (0, _defineProperty2["default"])(this, "useController", function (_ref) {
    var selectedState = _ref.selectedState;
    var _useSteps = (0, _useSteps2.useSteps)({
        selectedState: selectedState
      }),
      steps = _useSteps.steps,
      isLoadingSteps = _useSteps.isLoadingSteps,
      isFetchingSteps = _useSteps.isFetchingSteps;
    var _useImpactFilters = (0, _useImpactFilters2.useImpactFilters)(),
      impactFilters = _useImpactFilters.impactFilters;
    var _useThemeFilters = (0, _useThemeFilters2.useThemeFilters)(),
      themeFilters = _useThemeFilters.themeFilters;
    var _useCommitments = (0, _useCommitments2.useCommitments)({
        selectedState: selectedState
      }),
      commitments = _useCommitments.commitments,
      isLoadingCommitments = _useCommitments.isLoadingCommitments;
    var _useRecommendedSteps = (0, _useRecommendedSteps2.useRecommendedSteps)(),
      recommendedSteps = _useRecommendedSteps.recommendedSteps,
      isLoadingRecommendedSteps = _useRecommendedSteps.isLoadingRecommendedSteps;
    return {
      impactFilters: impactFilters,
      themeFilters: themeFilters,
      steps: steps,
      isLoadingSteps: isLoadingSteps || isLoadingCommitments,
      isFetchingSteps: isFetchingSteps,
      commitments: commitments,
      recommendedSteps: recommendedSteps,
      isLoadingRecommendedSteps: isLoadingRecommendedSteps
    };
  });
});